import { scroller } from "react-scroll";
import { Box, LazyImage } from "../Styled/Elements";
import { HeaderContainer } from "./Styled";
import { NavDataConfig } from "../data/Data";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsJustify, BsX } from "react-icons/bs";
import { Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { LogoEn, LogoAr } from "../Styled/AllImages";
import LangChangeButton from "../../Languages/LangChangeButton";
import styled from "styled-components";

const SecondaryHeader = ({ sidebarStatus, setSidebarStatus }) => {
  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);

  const handleToggle = () => {
    setSidebarStatus(!sidebarStatus);
  };

  const handleSignupButton = () => {
    // toast.error(t("select_plan_to_continue"))
    scroller.scrollTo("pricing", {
      duration: 500,
      smooth: true,
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <SecondaryHeaderContainer
        className={`${isSticky ? "sticky" : ""} container-fluid`}
      >
        <Container>
          <Box className="nav-bar">
            <Box className="d-flex">
              <span className="toggleBtn" onClick={handleToggle}>
                {sidebarStatus ? <BsX size={30} /> : <BsJustify size={30} />}
              </span>
              <LazyImage className="logo" src={LogoEn} />
            </Box>
            <Box className="whtLngWrapper d-flex align-items-center justify-content-center">
              <LangChangeButton />
            </Box>
          </Box>
        </Container>
      </SecondaryHeaderContainer>
    </>
  );
};

export default SecondaryHeader;

const SecondaryHeaderContainer = styled.div`
  height: 94px;
  width: calc(100% - 270px);
  position: fixed;
  top: 0;
  right: 0;
  -webkit-transition: all 0.3s ease-out 0s;
  transition: all 0.3s ease-out 0s;
  background: var(--white);
  border-bottom: 1px solid var(--border);
  z-index: 1001;
  height: 94px;
  body.rtl & {
    right: unset;
    left: 0;
  }
  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .logo {
    width: 179px;
    cursor: pointer;
    span {
      width: 100%;
    }
    img {
      width: 179px;
      height: auto;
      -webkit-transition: all 0.3s ease-out 0s;
      transition: all 0.3s ease-out 0s;
    }
  }
  /* &.sticky {
    background: var(--white);
    box-shadow: 0px 3px 10px #07758473;
    z-index: 200;
    .nav-bar {
      border: none;
    }
    .logo {
      svg {
        width: 80px;
        height: auto;
      }
    }
  } */
  .toggleBtn {
    display: none;
  }
  .whtLngWrapper {
    gap: 7px;
  }
  .headerBtn {
    background-color: var(--themeColor);
  }

  .Social-links {
    display: flex;
    gap: 12px;
    cursor: pointer;
  }
  .logo {
    display: none;
  }

  @media (max-width: 1199px) {
    .nav-bar button span {
      font-size: 14px;
    }
  }
  @media (max-width: 992px) {
    width: 100%;
    .logo {
      display: block;
    }
  }
`;
